"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyVersionOverride = void 0;
const client_1 = require("@wix/cashier-common/dist/src/utils/queryParams/client");
const config_1 = require("./config");
const applyVersionOverride = (settings) => {
    const { bannerStaticsBaseUrl, bannerVersion } = settings;
    try {
        const versionOverride = (0, client_1.getVersionOverrideFromQueryParams)(config_1.ARTIFACT_NAME);
        if (versionOverride) {
            settings.bannerVersion = versionOverride;
            settings.bannerStaticsBaseUrl = bannerStaticsBaseUrl.replace(bannerVersion, versionOverride);
        }
    }
    catch (e) {
        console.error(`Failed to apply version override`, e);
        // restore original values
        settings.bannerVersion = bannerVersion;
        settings.bannerStaticsBaseUrl = bannerStaticsBaseUrl;
    }
    return settings;
};
exports.applyVersionOverride = applyVersionOverride;
//# sourceMappingURL=applyVersionOverride.js.map